import { ServiceClient, type InterceptFn } from '@compassdigital/sdk.typescript';
import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { useLoadingStore } from '@centric-os/stores/loading/use-loading-store';

/**
 * Creates an intercept function that injects auth tokens and toggles the global loading state,
 * mirroring the behaviour of the existing axios request/response interceptors.
 */
function createIntercept(): InterceptFn {
  return async (req, fetch) => {
    const loadingStore = useLoadingStore();

    // TODO: replace this with a createTokenSource() that returns a token-provider
    // function, and pass an explicit `token: null` at the /user/auth call sites,
    // once the SDK version supporting a function token is published.
    if (!req.url.includes('/user/auth')) {
      const token = await useAuthStore().getValidAccessToken();
      if (token) {
        req.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    loadingStore.loading = true;
    try {
      return await fetch(req);
    } finally {
      loadingStore.loading = false;
    }
  };
}

/**
 * Creates a ServiceClient configured with auth-token injection and loading-state toggling.
 */
export function createServiceClient(): ServiceClient {
  return new ServiceClient({
    base_url: import.meta.env.VITE_CDL_ENDPOINT_BASE_URL,
    intercept: createIntercept(),
  });
}
